import { DateStringSchema, type ZodSimplify } from '@mntn-dev/utility-types'
import { z } from 'zod'
import { FinanceEntityIdSchema } from '../finance/finance-entity-id.ts'
import { PaymentIdSchema } from './payment-id.ts'
import { PaymentStatusSchema } from './payment-status.ts'
import { TipaltiIdSchema } from './tipalti-id.ts'

import { UnitSchema } from '../billing/unit.ts'
import { ProjectIdSchema } from '../unique-id.models.ts'
export const PaymentSchema = z.object({
  createdTime: DateStringSchema,
  updatedTime: DateStringSchema.optional(),
  paymentId: PaymentIdSchema,
  financeEntityId: FinanceEntityIdSchema,
  projectId: ProjectIdSchema,
  tipaltiId: TipaltiIdSchema,
  unit: UnitSchema,
  amount: z.number(),
  status: PaymentStatusSchema,
})

export type Payment = ZodSimplify<typeof PaymentSchema>
